<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>



<div class="page-content">

  <div *ngIf="canGoBack" class="back-container"><span class="back-btn" (click)="back()">< {{getString('back')}}</span></div>

  <div class="navigation-path">

    <span class="path-element">{{getString(store)}}</span>
    <span class="path-separator">»</span>
    <span class="path-element">{{getString(itemType)}}</span>
    <span class="path-separator">»</span>
    <a *ngIf="item && item.title" class="path-element" [href]="router.url">{{item.title}}</a>

  </div>

  <div class="detail-container">
    <div class="item-not-found" *ngIf="!showLoading && !item">{{getString('itemNotFound')}}</div>

    <div *ngIf="item" class="mobile-header-data">

        <div class="title"><h1>{{item.title}}</h1><span class="year">{{getReleaseYear()}}</span></div>
        <div *ngIf="item.itemType=='album' || item.itemType=='single'">{{item.artist}}</div>
        <div class="header-line">
          <span *ngIf="item.itemType == 'movie' || item.itemType == 'season'">
          <img alt="" *ngIf="!showLoading && showHDIcon" class="quality-icon" src="./assets/images/hd-icon.png">
          <img *ngIf="item.has3D == 1" class="quality-icon" alt="" src="./assets/images/3d-icon-avp-grey.png">
          <img *ngIf="item.has4K == 1" class="quality-icon" alt="" src="./assets/images/4k-icon.png">

          <img alt="" *ngIf="item.hdrFormat == 1" class="quality-icon" src="./assets/images/dolby_vision.png">
          <img alt="" *ngIf="item.hdrFormat == 2" class="quality-icon" src="./assets/images/hdr.png">

          <img alt="" *ngIf="item.hasAtmos == 1" class="quality-icon" src="./assets/images/dolby_atmos.png">
          </span>

          <img [title]="item.advisoryRating" [alt]="item.advisoryRating" *ngIf="getCountry() == 'us' && item.advisoryRating" class="advisory-rating-icon" [src]="getAdvisoryRatingIconUrl()">
          <img alt="iTunes Extras" *ngIf="item.iTunesExtra" class="itunes-extras-icon" src="./assets/images/itunes_extras.png">
        <img alt="Movies Anywhere" title="Movies Anywhere" *ngIf="item.moviesAnywhere" class="m-anywhere-icon" src="./assets/images/m_anywhere.png">
        </div>
        <app-ratings *ngIf="item.imdbRating || item.tomatoesScore" [useCompactLayout]="false" [imdbId]="item.imdbId" [imdbRating]="item.imdbRating"
        [tomatoesRating]="item.tomatoesScore" [letterboxdRating]="item.letterboxdRating" [letterboxdUrl]="item.letterboxdUrl" [metacriticRating]="item.metacritic" [tomatoesUrl]="item.tomatoesUrl" [metacriticUrl]="item.metacriticUrl"></app-ratings>
        <app-rating *ngIf="item.userRating" [rating]="item.userRating" [count]="item.userRatingCount" [bigImg]="true"></app-rating>

        <div class="type-label" *ngIf="item.isBundle || item.isMovieBundle || item.isSeasonBundle">{{getString('bundle')}}</div>

    </div>

    <div class="container" *ngIf="item != null">

      <ngx-json-ld [json]="schema"></ngx-json-ld>

      <div class="left-container">

        <div class="poster-wrapper">
          <div class="placeholder-container" *ngIf="showPlaceHolder">
            <img [alt]="item.title"  class="item-image placeholder-img" [class.hidden]="highResImageLoaded == true"
              src="./assets/images/item_placeholder.png">
            <div class="placeholder-text">{{item.title}}</div>
          </div>

          <div class="img-container" *ngIf="!showPlaceHolder">

            <img alt="" *ngIf="(!useIvan() || !storeIsItunes() || highResImageLoaded == false)" [class.hidden]="highResImageLoaded == true"
              class="item-image" [src]="getHttpsImageUrl()"
              (click)="showBigCover=true" [title]="getString('coverHoverText')"
              (error)="showPlaceHolder = true">

            <img alt="" *ngIf="useIvan() && storeIsItunes()" [class.hidden]="highResImageLoaded == false"
            class="item-image" [src]="getItemImageUrl()" (load)="highResImageLoaded = true"
            (error)="highResImageLoaded = false" (click)="showBigCover=true" [title]="getString('coverHoverText')">

          </div>

          <!-- Badges oben links auf dem Poster -->
          <span *ngIf="item.isPreorder == 1" class="preorder-badge-overlay">{{getString('preorder')}}</span>
          <span *ngIf="inOwnlist" class="owned-badge-overlay" [class.has-preorder]="item.isPreorder == 1">{{getString('purchased')}}</span>
          <span *ngIf="inBlocklist" class="blocked-badge-overlay" [class.has-preorder]="item.isPreorder == 1" [class.has-owned]="inOwnlist">
            <span class="material-icons blocked-icon">block</span>{{getString('blocked')}}
          </span>

          <!-- Wishlist-Indikator oben rechts auf dem Poster -->
          <ng-container *ngIf="inWishlist">
            <div class="wishlist-indicator-overlay"></div>
            <img alt="" class="wishlist-star-overlay" src="./assets/images/star_filled_blue.png">
          </ng-container>

        </div>

        <div class="bottom-left-container">

          <app-detail-price [item]="item" (onBuySelected)='onBuyChanged($event)'></app-detail-price>

          <div class="buy-button-container" (click)="buyButtonClick()" *ngIf="showAmazonUS()">
            <a *ngIf="item.productPageUrl" [attr.href]="getProductPageUrl(item.productPageUrl)" target="_blank" rel="nofollow">
              <img alt="" class="buy-button" [src]="getBuyButtonImageUrl()" [title]="getString('openInStore')">
            </a>
          </div>

          <div *ngIf="storeIsItunes() && mediaIsMusic()" class="buy-button-container" (click)="buyButtonClick()">
            <a *ngIf="item.productPageUrl" [attr.href]="getAppleMusicProductPageUrl(item.productPageUrl)" target="_blank" rel="nofollow">
              <img alt="" class="buy-button" [src]="getAppleMusicButtonImageUrl()" [title]="getString('openInStore')">
            </a>
          </div>

          <div *ngIf="storeIsAmazon()" class="ad">#ad</div>

        </div>

        <div class="mobile-wishlist-btn-meta-container">
          <div class="wishlist-btn-container" [class.list-btn-disabled]="wishlistLoading" (click)="wishlistStarClicked($event)">
            <img alt="" *ngIf="!inWishlist" class="wishlist-icon" src="./assets/images/star_lined_plus.png">
            <img alt="" *ngIf="inWishlist" class="wishlist-icon" src="./assets/images/star_filled_blue.png">
            <span *ngIf="!inWishlist" class="wishlist-text">{{getWishlistLabel()}}</span>
            <span *ngIf="inWishlist" class="wishlist-text">{{getString('removeFromWishlist')}}</span>
            <mat-spinner *ngIf="wishlistSpinnerVisible" class="list-btn-spinner" [diameter]="20"></mat-spinner>
          </div>

          <!-- Price Alert Card - Only for movies on wishlist -->
          <div class="price-alert-card" *ngIf="inWishlist && supportsPriceAlert()">
            <div class="price-alert-card-content">
              <div class="price-alert-icon-container">
                <span *ngIf="!priceAlertSaving" class="material-icons price-alert-bell-icon">notifications_active</span>
                <mat-spinner *ngIf="priceAlertSaving" class="price-alert-spinner" [diameter]="24"></mat-spinner>
              </div>
              <div class="price-alert-info">
                <span class="price-alert-label">{{getString('priceAlertNotifyWhenUnder')}}</span>
                <span class="price-alert-rental-tag" *ngIf="priceAlertIsRental">{{getString('priceAlertRent')}}</span>
                <div class="price-alert-price-list">
                  <div class="price-alert-price-item" *ngFor="let priceItem of getPriceAlertPrices()">
                    <img *ngIf="priceItem.quality === '4K' || priceItem.quality === 'HD/4K'" class="price-alert-quality-icon" src="./assets/images/4k-icon.png" alt="4K">
                    <img *ngIf="priceItem.quality === 'HD'" class="price-alert-quality-icon" src="./assets/images/hd-icon.png" alt="HD">
                    <span *ngIf="priceItem.quality === 'SD'" class="price-alert-quality-badge">SD</span>
                    <span class="price-alert-price-value">{{priceItem.price}}</span>
                  </div>
                </div>
              </div>
              <button class="price-alert-edit-btn" (click)="openPriceAlertModal()">
                <span class="material-icons">edit</span>
              </button>
            </div>
          </div>

          <div class="wishlist-btn-container" [class.list-btn-disabled]="ownlistLoading" (click)="ownlistStarClicked($event)">
            <img alt="" *ngIf="!inOwnlist" class="ownlist-icon" src="./assets/images/my_purchases_uncheck.png">
            <img alt="" *ngIf="inOwnlist" class="ownlist-icon" src="./assets/images/my_purchases_check.png">
            <span *ngIf="!inOwnlist" class="wishlist-text">{{getString('addToMyPurchases')}}</span>
            <span *ngIf="inOwnlist" class="wishlist-text">{{getString('removeFromMyPurchases')}}</span>
            <mat-spinner *ngIf="ownlistSpinnerVisible" class="list-btn-spinner" [diameter]="20"></mat-spinner>
          </div>

          <div>

            <div class="dropdown dd-click">
              <b class="dd-more dd-click" (click)="moreClicked()">{{getString("more")}}</b>
              <div #moreDDContent class="dropdown-content">
                <span class="dd-item dd-click" *ngIf="inBlocklist" (click)="removeFromBlocklist()">{{getString('removeFromBlocklist')}}</span>
                <span class="dd-item dd-click" *ngIf="!inBlocklist" (click)="addToBlocklist()">{{getString('addToBlocklist')}}</span>
                <span class="dd-item dd-click" (click)="copyItunesLink()">{{getString('copyItunesLink')}}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- TEMPORARILY DISABLED: Google Ads -->
        <!-- <app-ad-banner [type]="2"></app-ad-banner> -->

      </div>
      <div class="data-container">

        <div class="header-data">
          <div class="title"><h1>{{item.title}}</h1><span class="year">{{getReleaseYear()}}</span></div>
          <div *ngIf="item.itemType=='album' || item.itemType=='single'">{{item.artist}}</div>
          <div class="header-line">
            <span *ngIf="item.itemType == 'movie' || item.itemType == 'season'">
            <img alt="" *ngIf="!showLoading && showHDIcon" class="quality-icon" src="./assets/images/hd-icon.png">
            <img *ngIf="item.has3D == 1" class="quality-icon" alt="" src="./assets/images/3d-icon-avp-grey.png">
            <img *ngIf="item.has4K == 1" class="quality-icon" alt="" src="./assets/images/4k-icon.png">

            <img alt="" *ngIf="item.hdrFormat == 1" class="quality-icon" src="./assets/images/dolby_vision.png">
            <img alt="" *ngIf="item.hdrFormat == 2" class="quality-icon" src="./assets/images/hdr.png">

            <img alt="" *ngIf="item.hasAtmos == 1" class="quality-icon" src="./assets/images/dolby_atmos.png">
            </span>

            <img [title]="item.advisoryRating" [alt]="item.advisoryRating" *ngIf="getCountry() == 'us' && item.advisoryRating" class="advisory-rating-icon" [src]="getAdvisoryRatingIconUrl()">
          </div>
          <div class="header-line ratings-line" *ngIf="item.imdbRating || item.tomatoesScore">
            <app-ratings  [imdbId]="item.imdbId" [imdbRating]="item.imdbRating"
            [tomatoesRating]="item.tomatoesScore" [letterboxdRating]="item.letterboxdRating" [letterboxdUrl]="item.letterboxdUrl" [letterboxdRating]="item.letterboxdUrl" [metacriticRating]="item.metacritic" [tomatoesUrl]="item.tomatoesUrl" [metacriticUrl]="item.metacriticUrl"></app-ratings>
          </div>
          <app-rating *ngIf="item.userRating" [rating]="item.userRating" [count]="item.userRatingCount" [bigImg]="true"></app-rating>

          <div class="header-line" *ngIf="item.moviesAnywhere">
              <img alt="Movies Anywhere" title="Movies Anywhere" class="m-anywhere-icon" src="./assets/images/m_anywhere.png">
              <span>Movies Anywhere</span>
          </div>

          <div class="header-line-extras" *ngIf="item.iTunesExtra">
            <img alt="iTunes Extras" title="iTunes Extras" class="itunes-extras-icon" src="./assets/images/itunes_extras.png">
            <span class="itunes-extra">{{getString('itunesExtra')}}</span>
          </div>

          <div class="type-label" *ngIf="item.isBundle || item.isMovieBundle || item.isSeasonBundle">{{getString('bundle')}}</div>

        </div>

        <div *ngIf="item.saveOpportunity" class="section save-opportunity">
            {{getString('saveText1')}} <span class="save-price">{{formatPrice(item.saveOpportunity, item.currency)}}</span> {{getString('saveText2')}}
        </div>

        <div *ngIf="bundleOwnershipInfo" class="section bundle-ownership-info" role="note">
          <span class="material-icons bundle-ownership-icon" aria-hidden="true">info</span>
          <div class="bundle-ownership-text">
            <div class="bundle-ownership-title">{{getString('bundleOwnershipTitle')}}</div>
            <p>{{getString('bundleOwnershipSummary', { ownedCount: '' + bundleOwnershipInfo.ownedCount, totalCount: '' + bundleOwnershipInfo.totalCount })}}</p>
            <p>{{getString('bundleOwnershipBundlePrice', { missingCount: '' + bundleOwnershipInfo.missingCount, pricePerMissingMovie: bundleOwnershipInfo.pricePerMissingMovie, bundlePrice: bundleOwnershipInfo.bundlePrice })}}</p>
            <p>{{getString('bundleOwnershipSeparatePrice', { totalSeparatePrice: bundleOwnershipInfo.totalSeparatePrice })}}</p>
          </div>
        </div>

        <div *ngIf="item.isPreorder == 1" class="preorder-date-container">
          <div>{{getString('expectedReleaseDate')}}</div>
          <div class="expected-release-date">{{getExpectedReleaseDate()}}</div>
        </div>

        <div class="price-insight-container" [ngClass]="priceInsight?.cssClass">
          <p class="price-insight" [innerHTML]="priceInsight?.message"></p>
      </div>

        <div *ngIf="parentBundles && parentBundles.length > 0" class="also-included-wrapper">
          <app-bundle-carousel [bundles]="parentBundles" [country]="country" [useIvan]="useIvan()" [storeIsItunes]="storeIsItunes()" (onClick)="onBundleClick($event.event, $event.bundle)"></app-bundle-carousel>
        </div>

        <div *ngIf="getPriceEvolution() != ''" class="section price-information-section">
          <h2 class="section-title">{{getString('priceInformation')}}</h2>
          <app-price-information [item]="item" [currency]="item.currency" [isToBuy]="isToBuy"></app-price-information>
        </div>

        <div class="price-graph" *ngIf="!storeIsAmazon() && isPlatformDesktop() && hasMultiplePrices()">
          <app-graph [data]="priceEvoDataForGraph" [yAxisUnit]="item.currency"></app-graph>
        </div>

        <div class="price-evo-container" *ngIf="!storeIsAmazon() && getPriceEvolution() != ''">
          <h2 class="section-title">
            {{getPriceTrendTitle()}}
            <span class="price-trend-info-icon" (click)="togglePriceTrendLegend($event)" (mouseenter)="showPriceTrendLegend()" (mouseleave)="hidePriceTrendLegend()">?</span>
          </h2>
          <app-price-evolution [priceEvolution]="getPriceEvolution()" [currency]="item.currency"></app-price-evolution>
          <div #popupContent class="price-trend-legend" [class.show-legend]="priceTrendLegendVisible">
            <div class="legend-header" *ngIf="isMobile">
              <span class="close-icon" (click)="closePopup()">×</span>
            </div>
            <div class="legend-item">
              <span class="legend-color initial-price"></span>
              <span class="legend-text">{{getString('popup_initialPrice')}}</span>
            </div>
            <div class="legend-item">
              <span class="legend-color price-reduction"></span>
              <span class="legend-text">{{getString('popup_priceReduction')}}</span>
            </div>
            <div class="legend-item">
              <span class="legend-color price-increase"></span>
              <span class="legend-text">{{getString('popup_priceIncrease')}}</span>
            </div>
            <div class="legend-item">
              <span class="legend-color lowest-price"></span>
              <span class="legend-text">{{getString('popup_lowestPrice')}}</span>
            </div>
          </div>
        </div>

        <div *ngIf="item.summary && item.summary.indexOf('text/javascript') == -1" class="section description-container">
            <h2 class="section-title">{{getString('description')}}</h2>
            <app-expandable [textContent]="item.summary"></app-expandable>
        </div>

        <div *ngIf="item.iTunesExtraText" class="section description-container">
            <div class="section-title">{{getString('itunesExtra')}}</div>
            <app-expandable [textContent]="item.iTunesExtraText"></app-expandable>
        </div>

        <ng-container *ngIf="item.trailers && item.trailers.youtube">
          <div class="section-title">{{getString('trailer')}}</div>
            <app-horizontal-scroll scrollMode="item">
              <div class="trailer-container">
                <app-trailer *ngFor="let trailer of item.trailers.youtube" [trailer]="trailer"></app-trailer>
              </div>
            </app-horizontal-scroll>
        </ng-container>

        <div *ngIf="item.seasonFamily" class="section">
          <div class="section-title">{{getString('otherSeasons')}}</div>
          <app-other-seasons [items]="item.seasonFamily" (itemClicked)="otherSeasonClicked($event)" (onWishlistAction)="onSeasonWishlistAction($event)" (onOwnlistAction)="onSeasonOwnlistAction($event)"></app-other-seasons>
        </div>

        <div *ngIf="item.childSingles" class="section">
          <div class="section-title">{{getSongCount()}} {{getString('songsOnThisAlbum')}}</div>
          <app-child-singles [singles]="item.childSingles" (onSingleClicked)="singleClicked($event)"></app-child-singles>
        </div>

        <div *ngIf="isMovieBundleDetail()" class="section">
          <div class="section-title">{{getString('moviesInThisBundle')}}</div>
          <app-child-movies [movies]="item.childMovies" [currency]="item.currency" (onWishlistAction)="onChildMovieWishlistAction($event)" (onOwnlistAction)="onChildMovieOwnlistAction($event)"></app-child-movies>
        </div>

        <div *ngIf="item && (item.itemScreens || item.itemScreensiPad || (item.screenshots && item.screenshots.length))" class="section">
          <div class="section-title">{{getString('screenshots')}}</div>
          <app-horizontal-scroll-gallery [images]="getScreenshotsFromItem(item)" (onFullScreenMode)="openFullscreenGallery($event)"></app-horizontal-scroll-gallery>
        </div>

        <div class="section information-container">
          <h2 *ngIf="item.studio || item.directors || item.actors || item.audiotracks || item.subtitles || item.primaryGenreName || item.awards || item.vendorName || item.appVersion || item.minOsVersion || item.fileSize || item.plattform"
            class="section-title">{{getString('information')}}</h2>
          <table>
            <tr *ngIf="item.directors">
              <td class="row-title">{{getString('director')}}</td>
              <td><app-comma-separated [array]="item.directors" [label]="'name'" [key]="'id'" [type]="'directors'"></app-comma-separated></td>
            </tr>
            <tr *ngIf="item.writers">
              <td class="row-title">{{getString('writers')}}</td>
              <td><app-comma-separated [array]="item.writers" [label]="'name'" [key]="'id'" [type]="'writers'"></app-comma-separated></td>
            </tr>
            <tr *ngIf="item.actors">
              <td class="row-title">{{getString('actors')}}</td>
              <td><app-comma-separated [array]="item.actors" [label]="'name'" [key]="'id'" [type]="'actors'"></app-comma-separated></td>
            </tr>
            <tr *ngIf="item.audiotracks">
              <td class="row-title">{{getString('audiotracks')}}</td>
              <td>{{item.audiotracks}}</td>
            </tr>
            <tr *ngIf="item.subtitles">
              <td class="row-title">{{getString('subtitles')}}</td>
              <td>{{item.subtitles}}</td>
            </tr>
            <tr *ngIf="item.primaryGenreName">
              <td class="row-title">{{getString('genre')}}</td>
              <td>{{item.primaryGenreName}}</td>
            </tr>
            <tr *ngIf="item.pricePerMovie">
              <td class="row-title">{{getString('pricePerMovie')}}</td>
              <td>{{item.pricePerMovie}}</td>
            </tr>
            <tr *ngIf="isMovieBundleDetail()">
              <td class="row-title">{{getString('moviesInBundle')}}:</td>
              <td>{{item.childMovies.length}}</td>
            </tr>
            <tr *ngIf="item.awards">
              <td class="row-title">{{getString('awards')}}</td>
              <td>{{item.awards}}</td>
            </tr>
            <tr *ngIf="item.studio">
              <td class="row-title">{{getString('studio')}}</td>
              <td>
                <a *ngIf="getStudioLink()" [routerLink]="getStudioLink()">{{item.studio}}</a>
                <span *ngIf="!getStudioLink()">{{item.studio}}</span>
              </td>
            </tr>
            <tr *ngIf="item.vendorName">
              <td class="row-title">{{getString('vendorName')}}</td>
              <td>{{item.vendorName}}</td>
            </tr>
            <tr *ngIf="item.appVersion">
              <td class="row-title">{{getString('appVersion')}}</td>
              <td>{{item.appVersion}}</td>
            </tr>
            <tr *ngIf="item.minOsVersion">
              <td class="row-title">{{getString('minOsVersion')}}</td>
              <td>{{item.minOsVersion}}</td>
            </tr>
            <tr *ngIf="item.fileSize">
              <td class="row-title">{{getString('fileSize')}}</td>
              <td>{{getFileSize(item.fileSize)}}</td>
            </tr>
            <tr *ngIf="item.plattform">
              <td class="row-title">{{getString('platform')}}</td>
              <td>{{getPlatformName(item.plattform)}}</td>
            </tr>
            <tr *ngIf="item.runningTime">
              <td class="row-title">{{getString('runningTime')}}</td>
              <td>{{getRunningTime()}}</td>
            </tr>
            <tr *ngIf="item.has4K && storeIsItunes() && !item.isMovieBundle">
              <td class="row-title">{{getString('turned4Kinfo')}}</td>
              <td>{{getTurned4K()}}</td>
            </tr>
            <tr *ngIf="item.has3D">
              <td class="row-title">{{getString('turned3Dinfo')}}</td>
              <td>{{getTurned3D()}}</td>
            </tr>
          </table>

        </div>

        <div *ngIf="item.ymalMovies" class="section you-may-also-like-section">
          <h3 class="section-title">{{getString('youMayAlsoLike')}}</h3>
          <app-child-movies [movies]="item.ymalMovies" [currency]="item.currency" (onWishlistAction)="onChildMovieWishlistAction($event)" (onOwnlistAction)="onChildMovieOwnlistAction($event)"></app-child-movies>
        </div>

        <div *ngIf="item.moreByActors && item.moreByActors.length > 0" class="section more-from-actors-section">
          <h3 class="section-title">{{getString('moreFromActors')}}</h3>
          <app-child-movies [movies]="item.moreByActors" [currency]="item.currency" (onWishlistAction)="onChildMovieWishlistAction($event)" (onOwnlistAction)="onChildMovieOwnlistAction($event)"></app-child-movies>
        </div>

        <div *ngIf="item.moreByDirectors && item.moreByDirectors.length > 0" class="section more-from-director-section">
          <h3 class="section-title">{{getString('moreFromDirector')}} {{getFirstDirectorName()}}</h3>
          <app-child-movies [movies]="item.moreByDirectors" [currency]="item.currency" (onWishlistAction)="onChildMovieWishlistAction($event)" (onOwnlistAction)="onChildMovieOwnlistAction($event)"></app-child-movies>
        </div>

        <!-- TEMPORARILY DISABLED: Google Ads -->
        <!-- <app-ad-banner [type]="1" class="detail-view-ad-banner"></app-ad-banner> -->

        <div class="section" *ngIf="storeIsItunes()">
          <div class="section-title">{{getString('userReviews')}}</div>
          <app-reviews [reviews]="item.reviews" [idInStore]="item.idInStore || item.itemID" (needAuth)="authentication.openRegister()"></app-reviews>
        </div>

        <div *ngIf="item.shortUrl" class="section">
          <div class="section-title">{{getString('shareThisOffer')}}</div>
          <app-share [url]="item.shortUrl" [itemTitle]="item.title"></app-share>
        </div>

        <div *ngIf="storeIsAmazon()" class="amazon-small-text">
          CERTAIN CONTENT THAT APPEARS ON CHEAPCHARTS COMES FROM AMAZON. THIS CONTENT IS PROVIDED 'AS IS' AND IS SUBJECT TO CHANGE OR REMOVAL AT ANY TIME.
        </div>

      </div>

    </div>
  </div>

</div>

<div *ngIf="requestLoaded">
  <app-home-footer></app-home-footer>
</div>

<app-spinner-overlay *ngIf="showLoading"></app-spinner-overlay>

<app-fullscreen-gallery *ngIf="fullscreenGalleryIsOn == true && item" [images]="getScreenshotsFromItem(item)" [position]="fullscreenGalleryPosition" (onClose)="fullscreenGalleryIsOn = false"></app-fullscreen-gallery>


<app-authentication #authentication></app-authentication>

<!-- Price Alert Modal -->
<app-price-alert-modal
  #priceAlertModal
  [item]="item"
  [currency]="item?.currency"
  [store]="store"
  (onSave)="onPriceAlertSave($event)"
  (onRemove)="onPriceAlertRemove()">
</app-price-alert-modal>
